module.exports = __webpack_public_path__ + "img/img.76f37e18.png";